module.exports = __webpack_public_path__ + "img/yve.8fe5770d.png";